const SmsSent = () => {
  return (
    <svg
      width='72'
      height='72'
      viewBox='0 0 72 72'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_21972_3771)'>
        <path
          d='M56.1429 0H15.8571C7.09948 0 0 7.09949 0 15.8572V56.1429C0 64.9005 7.09948 72 15.8571 72H56.1429C64.9005 72 72 64.9005 72 56.1429V15.8572C72 7.09949 64.9005 0 56.1429 0Z'
          fill='url(#paint0_linear_21972_3771)'
        />
        <path
          d='M36 12C29.6348 12 23.5303 14.3521 19.0295 18.5386C14.5286 22.7252 12 28.4035 12 34.3242C12.0058 38.1753 13.0826 41.9596 15.1256 45.3092C17.1687 48.6588 20.1085 51.4598 23.6595 53.44C22.7138 55.8045 21.2953 58.0218 19.4629 60C23.0164 59.3034 26.3521 57.84 29.2104 55.7237C31.4143 56.3328 33.7009 56.6443 36 56.6484C42.3652 56.6484 48.4697 54.2963 52.9705 50.1097C57.4714 45.9232 60 40.2449 60 34.3242C60 28.4035 57.4714 22.7252 52.9705 18.5386C48.4697 14.3521 42.3652 12 36 12Z'
          fill='white'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_21972_3771'
          x1='36.5714'
          y1='67.2206'
          x2='36.5714'
          y2='8.93553'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#0CBD2A' />
          <stop offset='1' stopColor='#5BF675' />
        </linearGradient>
        <clipPath id='clip0_21972_3771'>
          <rect width='72' height='72' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SmsSent;
